import { createSelector } from 'reselect';

export const selectParkingVouchersSlice = state => state.parkingVouchers;

export const selectParkingVouchers = createSelector(
  selectParkingVouchersSlice,
  slice => slice.parkingVouchers
);
export const parkingVouchersLoaded = createSelector(
  selectParkingVouchersSlice,
  slice => slice.parkingVouchersLoaded
);
export const selectActiveParkingVoucher = createSelector(
  selectParkingVouchersSlice,
  slice => slice.activeParkingVoucher
);

export const parkingVouchersMeta = createSelector(
  selectParkingVouchersSlice,
  slice => slice.meta
);
export const parkingVouchersFilters = createSelector(
  selectParkingVouchersSlice,
  slice => slice.filters
);

export const parkingVouchersCreating = createSelector(
  selectParkingVouchersSlice,
  slice => slice.isCreating
);
export const parkingVouchersUpdating = createSelector(
  selectParkingVouchersSlice,
  slice => slice.isUpdating
);
export const parkingVouchersDeleting = createSelector(
  selectParkingVouchersSlice,
  slice => slice.isDeleting
);
export const parkingVouchersErrors = createSelector(
  selectParkingVouchersSlice,
  slice => slice.errors
);
